export default  {
    computed: {
        currencyList() {
            return ['CZK', 'EUR', 'USD'];
        }
    }
}